// extracted by mini-css-extract-plugin
module.exports = {"bread_crumbs":"BreadCrumbs_bread_crumbs__zahb5","bread_crumbs_list":"BreadCrumbs_bread_crumbs_list__ySM7d","bread_crumbs_item":"BreadCrumbs_bread_crumbs_item__PuU9O"};